/*
 * assets/search-title-first.js
 * Stag Provisions - header search dropdown, title-first product order.
 *
 * Replaces getSearchResults() on the theme's <predictive-search> element at runtime,
 * so assets/theme.js and assets/theme.dev.js do not need to be edited.
 *
 * Two requests run in parallel:
 *   1. Predictive search (sections/predictive-search.liquid) - categories, "Show all results", layout.
 *   2. Full search (sections/search-title-products.liquid) - up to 50 products ranked:
 *      title (all words) > title (any word) > vendor / type / tags > everything else.
 * The product grids from request 1 are replaced with the ranked products from request 2.
 * If request 2 fails or returns nothing, the normal predictive products are shown.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '#shopify-section-predictive-search';

  function buildUrls(term) {
    var predictiveBase = window.theme.routes.predictive_search_url;
    var searchBase = predictiveBase.replace(/\/suggest$/, '');
    var q = encodeURIComponent(term);

    var predictiveUrl =
      predictiveBase +
      '?q=' + q +
      '&' + encodeURIComponent('resources[limit]') + '=10' +
      '&' + encodeURIComponent('resources[limit_scope]') + '=each' +
      '&' + encodeURIComponent('resources[options][fields]') + '=title,product_type,vendor,tag,variants.title' +
      '&section_id=predictive-search';

    var titleUrl =
      searchBase +
      '?q=' + q +
      '&type=product' +
      '&' + encodeURIComponent('options[prefix]') + '=last' +
      '&section_id=search-title-products';

    return { predictiveUrl: predictiveUrl, titleUrl: titleUrl };
  }

  function getSearchResults(term) {
    var self = this;
    var queryKey = term.replace(' ', '-').toLowerCase();

    self.setLiveRegionLoadingState();

    if (self.cachedResults[queryKey]) {
      self.renderSearchResults(self.cachedResults[queryKey]);
      return;
    }

    var signal = self.abortController.signal;
    var urls = buildUrls(term);

    var predictiveRequest = fetch(urls.predictiveUrl, { signal: signal }).then(function (response) {
      if (!response.ok) {
        var error = new Error(response.status);
        self.close();
        throw error;
      }
      return response.text();
    });

    var titleRequest = fetch(urls.titleUrl, { signal: signal })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .catch(function (error) {
        if (error && error.code === 20) throw error; // aborted: a newer search started
        return '';
      });

    Promise.all([predictiveRequest, titleRequest])
      .then(function (results) {
        var predictiveHtml = results[0];
        var titleHtml = results[1];

        var section = new DOMParser().parseFromString(predictiveHtml, 'text/html').querySelector(SECTION_SELECTOR);
        if (!section) return;

        if (titleHtml) {
          var titleDoc = new DOMParser().parseFromString(titleHtml, 'text/html');
          var desktopItems = titleDoc.querySelector('[data-title-products-desktop]');
          var mobileItems = titleDoc.querySelector('[data-title-products-mobile]');
          var desktopGrid = section.querySelector('.desktop-search-column .grid');
          var mobileGrid = section.querySelector('.mobile-search-column .grid');

          if (desktopItems && desktopItems.children.length && desktopGrid) {
            desktopGrid.innerHTML = desktopItems.innerHTML;
          }
          if (mobileItems && mobileItems.children.length && mobileGrid) {
            mobileGrid.innerHTML = mobileItems.innerHTML;
          }
        }

        var markup = section.innerHTML;
        self.allPredictiveSearchInstances.forEach(function (instance) {
          instance.cachedResults[queryKey] = markup;
        });
        self.renderSearchResults(markup);
      })
      .catch(function (error) {
        if (error && error.code === 20) return; // aborted
        self.close();
        throw error;
      });
  }

  customElements.whenDefined('predictive-search').then(function () {
    var PredictiveSearch = customElements.get('predictive-search');
    PredictiveSearch.prototype.getSearchResults = getSearchResults;

    // Drop any results cached before this override loaded
    document.querySelectorAll('predictive-search').forEach(function (element) {
      if (element.cachedResults) element.cachedResults = {};
    });
  });
})();